import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const useTokenExpiration = () => {
	const navigate = useNavigate();

	useEffect(() => {
		const handleTokenExpired = () => {
			// Navigate to login page when token expires
			navigate("/login", { replace: true });
		};

		// Listen for token expiration events
		window.addEventListener("tokenExpired", handleTokenExpired);

		// Cleanup event listener
		return () => {
			window.removeEventListener(
				"tokenExpired",
				handleTokenExpired
			);
		};
	}, [navigate]);
};
